import { createFileRoute } from '@tanstack/react-router';

import { getCourseOptions } from '@/module/Author/Course';

export const Route = createFileRoute('/_auth/author/_author/course/_course/$courseId/_layout')({
  loader: async ({ params: { courseId }, context: { queryClient } }) => {
    const course = await queryClient.ensureQueryData(getCourseOptions(courseId));

    return {
      course,
      crumb: course.title,
    };
  },
});
